import { Routes } from "@angular/router";
import { AppLayout } from "./layouts/app-layout";

export const routes: Routes = [
  {
    path: "",
    component: AppLayout,
    children: [
      // {
      //     path: '',
      //     loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      // },
      {
        path: "",
        loadChildren: () =>
          import("./pages/pages.route").then((m) => m.PageRouting),
      },
    ],
  },
];
